import { Box } from '@mui/material'
import { VendorInsights } from './VendorInsights'
import { PartnerInsights } from './PartnerInsights'
import { isVendor } from '../../../authProvider'

export const Insights = () => {
  return <Box>{isVendor() ? <VendorInsights /> : <PartnerInsights />}</Box>
}
